import React, { createContext, useContext, useEffect, useState } from 'react';

export const CURRENCIES = [
  { code: 'USD', symbol: '$', label: 'US Dollar' },
  { code: 'EUR', symbol: '€', label: 'Euro' },
  { code: 'GBP', symbol: '£', label: 'British Pound' },
  { code: 'INR', symbol: '₹', label: 'Indian Rupee' },
  { code: 'CAD', symbol: 'C$', label: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', label: 'Australian Dollar' },
  { code: 'JPY', symbol: '¥', label: 'Japanese Yen' },
];

const CurrencyContext = createContext({
  currency: CURRENCIES[0],
  setCurrencyCode: () => {},
});

export function CurrencyProvider({ children }) {
  const [code, setCode] = useState(() => {
    try { return localStorage.getItem('ce_currency') || 'USD'; } catch { return 'USD'; }
  });
  useEffect(() => {
    try { localStorage.setItem('ce_currency', code); } catch { /* ignore */ }
  }, [code]);
  const currency = CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];
  return (
    <CurrencyContext.Provider value={{ currency, setCurrencyCode: setCode }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);

export const formatMoney = (value, currency, opts = {}) => {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  const decimals = opts.decimals ?? (currency.code === 'JPY' ? 0 : 2);
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.code,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(value);
  } catch {
    return `${currency.symbol}${Number(value).toFixed(decimals)}`;
  }
};

export const formatNumber = (value, decimals = 2) => {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};
